
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import newsItem from './NewsItem.vue'

export default {
name: 'newscenter',
props: {
firstload: {
type: Boolean,
required: false,
default: false
},
pageSize: {
type: Number,
required: false,
default: 10
},
haveLoadMore: {
type: Boolean,
required: false,
default: true
},
firstactive: {
required: false,
default: 0
}
},
data () {
return {
active: 0,
urllist: [
'ch02',

'ch08',
'ch09',
'ch04',
'ch03'
] // 新闻栏目名称
}
},
components: {
Tab,
TabItem,
newsItem
},
created () {
this.active = this.firstactive || 0
},
methods: {
gotoList () {
this.$router.push({
name: 'newscenter',
query: { firstactive: this.active }
})
}
}
}
